import { PortalDialogProps } from "@app/services/modal.service";
import Modal from "../modal/modal.component";
import Input from "../input";
import Button from "../button";
import { Form, Formik, FormikContextType } from "formik";
import { createRef, useEffect } from "react";
import { createAlertSystemValidationSchema } from "@app/validations";
import { FormControl } from "../form-control";
import { AlertSystem, CreateAlertSystem } from "@app/types";

interface AlertSystemModalProps {
  isEdit: boolean;

  alertSystem: AlertSystem;
}

function AlertSystemModal({
  portalDialogRef,
  portalData,
}: PortalDialogProps<AlertSystemModalProps>) {
  const formRef = createRef<FormikContextType<CreateAlertSystem>>();

  const onSubmit = (values: CreateAlertSystem) => {
    portalDialogRef.close({ alertSystem: values });
  };

  useEffect(() => {
    if (portalData?.alertSystem && formRef.current) {
      formRef.current.setValues({
        message: portalData.alertSystem.message,
      });
    }
  }, [portalData?.alertSystem]);

  return (
    <Modal onCancel={portalDialogRef.close}>
      <div className="w-[423px] py-7 px-6">
        <div className="text-black font-semibold text-xl">
          {portalData?.isEdit ? "Chỉnh sửa" : "Thêm thông báo"}
        </div>
        <Formik
          initialValues={{ message: "" }}
          onSubmit={onSubmit}
          innerRef={formRef}
          validationSchema={createAlertSystemValidationSchema}
          validateOnChange
          validateOnBlur
        >
          <Form>
            <FormControl name="message">
              <Input
                inputClassName="text-[#2C2D33]"
                className="mt-7"
                placeholder="Thông báo"
              />
            </FormControl>
            <div className="mt-11 flex justify-center gap-4">
              <Button
                size="xs"
                label="Hủy"
                theme="secondary"
                width={180}
                className="!h-[51px] !leading-[51px]"
                labelClassName="text-xl"
                onClick={portalDialogRef.close}
              />
              <Button
                type="submit"
                size="xs"
                label={portalData?.isEdit ? "Lưu" : "Thêm"}
                width={180}
                className="!h-[51px] !leading-[51px]"
                labelClassName="text-xl"
              />
            </div>
          </Form>
        </Formik>
      </div>
    </Modal>
  );
}

export default AlertSystemModal;
